import store from '../store'
import { storageGet } from '@/services/storage'

function auth(to, from, next) {
	const user = storageGet('@stup:user')
	if (!user) {
		next('login')
	}

	if (store.state.user.permissions) {
		const permission = store.state.user.permissions.find(e => e.slug === to.name.toLowerCase())

		if (permission && !permission.role.read) {
			next('error')
		}
	}

	return next()
}

export default auth
